import { ReactNode } from "react";
import { InputV2 } from "../inputs/Input";
import { XClose } from "@untitled-ui/icons-react";
import { FormFieldWrapper } from "./helpers/FieldWrapper";
import { Dropdown } from "@lockerpm/design";
import { DropdownItemRenderV2 } from "../antdHelpers/DropdownItemRender";
import { IFilterItemV2 } from "../Table/Filter/types";
import { DropdownRenderV2 } from "../antdHelpers/DropdownRender";

interface IFormSelectMultipleV2Props {
  id?: string;
  label: string;
  keyword: string;
  onChangeKeyword: (newKeyword: string) => void;
  values: IFilterItemV2[];
  onChangeValues: (newValues: IFilterItemV2[]) => void;
  options: IFilterItemV2[];
  hint?: ReactNode;
  requiredMark?: boolean;
  placeholder?: string;
  column?: number;
}

export const FormSelectMultipleV2 = ({
  id,
  label,
  keyword,
  onChangeKeyword,
  values,
  onChangeValues,
  options,
  hint,
  requiredMark = false,
  placeholder,
  column,
}: IFormSelectMultipleV2Props) => {
  const syncWidthId = "dropdown-input-" + id;

  // ---------------- METHODS ----------------

  const onAddValue = (clicked: IFilterItemV2) => {
    onChangeValues([...values, clicked]);
  };

  const onRemoveValue = (clicked: IFilterItemV2) => {
    onChangeValues(values.filter((item) => item.key !== clicked.key));
  };

  // ---------------- RENDER ----------------

  return (
    <FormFieldWrapper
      label={label}
      requiredMark={requiredMark}
      error={null}
      hint={hint}
    >
      <div
        style={{ gridTemplateColumns: `repeat(${column}, minmax(0, 1fr))` }}
        className="grid gap-x-6 gap-y-1.5"
      >
        {values.map((item) => (
          <div
            key={item.key}
            className="bg-white border border-gray-v2-300 shadow-xs rounded-lg px-3 py-2 text-md text-gray-v2-900 flex items-center justify-between"
          >
            <div className="flex items-center gap-2">
              {item.leftIcon}
              {item.getLabel()}
            </div>
            <XClose
              className="h-4 w-4 min-w-4 text-gray-v2-400 cursor-pointer"
              onClick={() => {
                onRemoveValue(item);
              }}
            />
          </div>
        ))}
        <Dropdown
          menu={{
            items: options
              .filter((item) => !values.map((v) => v.key).includes(item.key))
              .map((item) => ({
                key: item.key,
                label: (
                  <DropdownItemRenderV2
                    label={
                      <>
                        {item.leftIcon ? item.leftIcon : null}
                        {item.getLabel()}
                      </>
                    }
                    isSelected={false}
                  />
                ),
              })),
            onClick: ({ key }) => {
              const selected = options.find((item) => item.key === key);
              if (selected) {
                onAddValue(selected);
              }
            },
          }}
          dropdownRender={(menu) => (
            <DropdownRenderV2 syncWidthId={syncWidthId}>
              {menu}
            </DropdownRenderV2>
          )}
          trigger={["click"]}
        >
          <InputV2
            id={syncWidthId}
            value={keyword}
            onChange={(e) => {
              onChangeKeyword(e.target.value);
            }}
            placeholder={placeholder}
          />
        </Dropdown>
      </div>
    </FormFieldWrapper>
  );
};
